import { render, staticRenderFns } from "./SimStockManagement.vue?vue&type=template&id=38629d5a&scoped=true&"
import script from "./SimStockManagement.vue?vue&type=script&lang=ts&"
export * from "./SimStockManagement.vue?vue&type=script&lang=ts&"
import style0 from "./SimStockManagement.vue?vue&type=style&index=0&id=38629d5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38629d5a",
  null
  
)

export default component.exports